module.exports = __webpack_public_path__ + "img/misparaim_yes.0f7ccb7c.png";